// ignore-string-externalization
import { screenSmMax, screenXsMax, spacer12, spacer24, spacer20, spacer32, spacer40, spacer64 } from '@spotify-internal/encore-foundation';
import { Type, TypeList, TypeListItem } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { transformScaleUp } from '../../utils';
export var FooterWrapper = styled.footer.withConfig({
  displayName: "Footerstyles__FooterWrapper",
  componentId: "sc-1jxvod4-0"
})(["padding:", ";display:flex;flex-flow:row wrap;justify-content:flex-start;background:", ";&,& a{color:", ";}a:focus img{", ";}@media (max-width:", "){padding:", " ", ";}", "{list-style:none;padding-left:0;}"], spacer40, function (_ref) {
  var theme = _ref.theme;
  return theme.box.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.nav.text;
}, transformScaleUp, screenSmMax, spacer40, spacer20, TypeList.ul);
export var Copyright = styled(Type.small).attrs({
  variant: 'body2'
}).withConfig({
  displayName: "Footerstyles__Copyright",
  componentId: "sc-1jxvod4-1"
})([""]);
export var FooterSection = styled.div.withConfig({
  displayName: "Footerstyles__FooterSection",
  componentId: "sc-1jxvod4-2"
})(["header{padding-right:", ";}&:first-of-type{flex:1;}:not(:first-of-type),:not(:last-of-type){margin-right:", ";}&:last-of-type{width:100%;}", "{margin-bottom:", ";", "{margin:", " 0;}}@media (max-width:", "){width:100%;&:first-of-type{margin-bottom:", ";}}"], spacer64, spacer40, TypeList.ul, spacer32, TypeListItem, spacer12, screenXsMax, spacer24);
export var SectionHeader = styled(Type.h2).attrs({
  variant: Type.body1,
  weight: Type.bold,
  condensed: true
}).withConfig({
  displayName: "Footerstyles__SectionHeader",
  componentId: "sc-1jxvod4-3"
})([""]);
export var InlineList = styled(TypeList.ul).withConfig({
  displayName: "Footerstyles__InlineList",
  componentId: "sc-1jxvod4-4"
})(["display:flex;flex-flow:row nowrap;"]);
export var CircleIcon = styled.div.withConfig({
  displayName: "Footerstyles__CircleIcon",
  componentId: "sc-1jxvod4-5"
})(["color:", ";border:1px solid ", ";border-radius:100%;width:42px;height:42px;padding:", ";margin-right:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.nav.text;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.nav.text;
}, spacer12, spacer12);